import { render, staticRenderFns } from "./Payment-schedule-details.vue?vue&type=template&id=769f54ca"
import script from "./Payment-schedule-details.vue?vue&type=script&lang=js"
export * from "./Payment-schedule-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports